<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Commissions"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create commissions."
      @on-submit="createCommissionImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Commissions Template.xlsx"
              :file-provider="$importsAPI.getCommissionsTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CommissionsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'commissions-imports-add-modal',
    };
  },
  methods: {
    createCommissionImport(data, handleCreate) {
      handleCreate(this.$importsAPI.commissionsCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
